import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import Chart from 'assets/livenicons/anxiety_level1.svg';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { SaveAnswer } from 'analytics/AllEvents';
import { pushWithSearchQuery } from 'utils';
import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

export const AnxietyLevel: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(pushWithSearchQuery('/wellness-subscription'));
    }, 250);
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>Your ADHD signs level</p>
      <div className={styles.content}>
        <img src={Chart} alt="" />
        <p className={styles.info}>
          The chart is a non-customized illustration and results may vary
        </p>
      </div>
      <h3 className={styles.title}>
        Your personal <br />
        <span className={styles.accent}>ADHD Management Plan</span> <br />
        is ready
      </h3>
      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
